import {
  SERVICE_STATUS_COLORS,
  DEFAULT_SERVICE_STATUS_COLOR,
} from '../constants';

export function getStatusColor(category: string): string {
  return SERVICE_STATUS_COLORS[category] || DEFAULT_SERVICE_STATUS_COLOR;
}
